import type { MusicVideoCutSummary, MusicVideoEditorResponse } from 'fym-shared/src/music24/musicVideoApi';

/** True when the editor must make the first cut: a song with a master and no cut. Pure. */
export function needsFirstCut(data: Pick<MusicVideoEditorResponse, 'songMap' | 'cuts'> | undefined): boolean {
  return data !== undefined && data.songMap !== null && data.cuts.length === 0;
}

/**
 * The cut the editor opens: the cut of `?cut=` when the song has it, else a cut made in this visit
 * (the first cut, a new cut), else the newest cut (the highest number). Null with no cut. Pure.
 */
export function openCutChoice(
  cuts: readonly MusicVideoCutSummary[],
  wanted: string | null,
  created: string | null
): string | null {
  if (wanted !== null && cuts.some((cut) => cut.uuid === wanted)) {
    return wanted;
  }
  if (created !== null && cuts.some((cut) => cut.uuid === created)) {
    return created;
  }
  let newest: MusicVideoCutSummary | null = null;
  for (const cut of cuts) {
    if (newest === null || cut.number > newest.number) {
      newest = cut;
    }
  }
  return newest?.uuid ?? null;
}
